/**
 * JSONデータからSupplyChainInfoを解析し、各セグメントのdasharrayとdashoffsetを計算
 * @param {Object} data - JSONデータ全体 (SupplyChainInfoを含む)
 * @param {number} circumference - 円周長 (デフォルトは251.33)
 * @returns {Array} - 計算されたdasharrayとdashoffsetを含むセグメントデータ
 */
export function calculateEmissionSegmentsFromJSON(data, circumference = 251.33) {
  const supplyChainInfo = data.SupplyChainInfo;

  // 各プロセスの順序を定義（12時の位置に来る順番）
  const processOrder = {
    rawMaterial: 0,
    spinning: 1,
    sewing: 2,
    dyeing: 3
  };

  // SupplyChainInfo内のco2Emissionの合計を計算
  const segments = Object.keys(supplyChainInfo).map((key) => {
    const item = supplyChainInfo[key];
    return {
      co2Emission: parseFloat(item.co2Emission) || 0,
      color: getColorForProcess(key), // 各プロセスの色を取得
      order: processOrder[key] // 各プロセスの順序を設定
    };
  });

  const totalEmission = segments.reduce((sum, segment) => sum + segment.co2Emission, 0);

  // order順に並べ替え
  segments.sort((a, b) => a.order - b.order);

  let cumulativeOffset = 0;
  return segments.map((segment) => {
    const segmentLength = (segment.co2Emission / totalEmission) * circumference;
    const segmentStyle = {
      color: segment.color,
      dasharray: `${segmentLength} ${circumference}`,
      dashoffset: `-${cumulativeOffset}`
    };
    cumulativeOffset += segmentLength;
    return segmentStyle;
  });
}

  
  /**
   * 各プロセスのキーに基づいて色を決定
   * @param {string} processKey - プロセスのキー (e.g., 'rawMaterial', 'spinning')
   * @returns {string} - 色コード
   */
  function getColorForProcess(processKey) {
    const colorMap = {
      rawMaterial: 'var(--segment-green)',
      spinning: 'var(--segment-purple)',
      weaving: 'var(--segment-yellow)',
      sewing: 'var(--segment-blue)',
      dyeing: 'var(--segment-turquoise)'
      
    };
    return colorMap[processKey] || '#000'; // デフォルト色
  }
  

/**
 * JSONデータのSupplyChainInfo内のco2Emissionとco2Absorptionの合計を計算する関数
 * @param {Object} data - JSONデータ
 * @returns {Object} - { totalEmission, totalAbsorption } というオブジェクト
 */
export function calculateTotalEmissionsAndAbsorption(data) {
    if (!data || !data.SupplyChainInfo) return { totalEmission: 0, totalAbsorption: 0 };
  
    const supplyChainInfo = data.SupplyChainInfo;
  
    // co2Emissionとco2Absorptionの合計をそれぞれ計算
    const totalEmission = Object.values(supplyChainInfo).reduce(
      (sum, segment) => sum + parseFloat(segment.co2Emission || 0),
      0
    );
  
    const totalAbsorption = Object.values(supplyChainInfo).reduce(
      (sum, segment) => sum + parseFloat(segment.co2Absorption || 0),
      0
    );
  
    return { totalEmission, totalAbsorption };
  }
  